import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { restURL } from '../../../Models/restURL';
import { userService } from '../../../Services/userService';
import { LanguageService } from '../../../Services/languageService';
import { Subscription } from 'rxjs';
import { renewPolicyModel } from '../../../Models/policyModel';
import { mdlCheckEligibilityReq } from '../../../Models/mdlCheckEligibilityReq';
import { mdlCheckEligibilityRes } from '../../../Models/mdlCheckEligibilityRes';
import Swal from 'sweetalert2';
import { mdlBindInfoCompRenewalRes } from '../../../Models/mdlBindInfoCompRenewalRes';
import { mdlBindInfoCompRenewalReq } from '../../../Models/mdlBindInfoCompRenewalReq';
import { mdlSelectedAddCovers } from '../../../Models/mdlSelectedAddCovers';
import { mdlProposalAddReq_Upgrade } from '../../../Models/mdlProposalAddReq_Upgrade';
import { mdlBindInfoUpgradeReq } from '../../../Models/mdlBindInfoUpgradeReq';
import { mdlBindInfoUpgradeRes } from '../../../Models/mdlBindInfoUpgradeRes';



@Component({
    selector: 'Upgrade',
    templateUrl: './Upgrade.html',
    styleUrls: ['./Upgrade.css']
})

export class Upgrade {

    public isShowLoading: boolean = false;
    public subscription: Subscription;
    public LngSubscription: Subscription;
    public Lng: string;
    public objBindInfoReq: mdlBindInfoUpgradeReq = new mdlBindInfoUpgradeReq();
    public objBindInfoRes: mdlBindInfoUpgradeRes = new mdlBindInfoUpgradeRes();
    public UpgradePolicyNo: string;
    public objCheckEligibilityReq: mdlCheckEligibilityReq = new mdlCheckEligibilityReq();
    public objCheckEligibilityRes: mdlCheckEligibilityRes = new mdlCheckEligibilityRes();
    public objSelectedCovers: mdlSelectedAddCovers = new mdlSelectedAddCovers();
    public objProposalAddReq_Upgrade: mdlProposalAddReq_Upgrade = new mdlProposalAddReq_Upgrade();


    constructor(private router: Router, private http: HttpClient, private url: restURL, private userinfo: userService, private lngService: LanguageService) {

        this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
        if (sessionStorage.getItem("Language") != null) {
            this.Lng = sessionStorage.getItem("Language");
        }
        else {
            this.Lng = "en";
        }
        this.UpgradePolicyNo = JSON.parse(sessionStorage.getItem("UpgradePolicy"));
        this.bindInfo();
    }



    bindInfo() {

        this.objBindInfoReq.PolicyNo = this.UpgradePolicyNo;
        this.isShowLoading = true;
        this.http.post<mdlBindInfoUpgradeRes>(this.url.UpgradeURL + "Motor/BindInfoUpgrade", this.objBindInfoReq, this.userinfo.getHttpOptions())
            .toPromise().then((result) => {
                this.isShowLoading = false;
                if (result.StatusCode == '1') {
                    this.objBindInfoRes = result;  
                } else {
                    if (result.ErrorMsg != null) {
                        Swal(result.ErrorMsg, "Info", "warning");
                    }
                    else {
                        Swal("Details Not Found/Another Proposal Exists", "Info", "warning");
                    }
                    this.router.navigate(['/NewDashboard/Policy']);
                }

            }, (error) => {
                this.isShowLoading = false;
            });
    }



    ValidateSpecialChar(event) {
        var k;
        k = event.charCode;
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    }


    ProceedToUpgrade(valid) {
        this.objCheckEligibilityReq.PolicyNo = this.objBindInfoRes.PolicyNo;
        this.objCheckEligibilityReq.SumInsured = this.objBindInfoRes.SumInsured;
        this.objCheckEligibilityReq.DeductableType = this.objBindInfoRes.DeductableType;
        this.objCheckEligibilityReq.RepairType = this.objBindInfoRes.RepairType;
        this.isShowLoading = true;
        this.http.post<mdlCheckEligibilityRes>(this.url.UpgradeURL + "Motor/CheckEligibility", this.objCheckEligibilityReq, this.userinfo.getHttpOptions()).toPromise()
            .then((EligibilityResponse) => {
                this.isShowLoading = false;
                this.objCheckEligibilityRes = EligibilityResponse;
                if (this.objCheckEligibilityRes.STATUS_CODE == "0") {
                    Swal(this.objCheckEligibilityRes.ERROR_MSG);
                    this.router.navigate(['/NewDashboard/Policy']);
                } else {
                    this.objSelectedCovers.PAB = 0;
                    this.objSelectedCovers.DAB = 0;
                    this.objSelectedCovers.BAHRAIN = 0;
                    this.objSelectedCovers.Geographical_EJL = 0;
                    this.objSelectedCovers.Geographical_Inc_Bahrain = 0;
                    this.objSelectedCovers.VEHICLE_REP = 0;
                    this.objSelectedCovers.ZERO_DEP = 0;
                    this.objProposalAddReq_Upgrade.RegNo=sessionStorage.getItem("RegNo");
                    this.objProposalAddReq_Upgrade.PolicyNo = this.objBindInfoRes.PolicyNo
                    sessionStorage.setItem("objSelectedCovers", JSON.stringify(this.objSelectedCovers));
                    sessionStorage.setItem("objProposalAddReq_Upgrade", JSON.stringify(this.objProposalAddReq_Upgrade));
                    sessionStorage.setItem("objCheckEligibilityRes", JSON.stringify(this.objCheckEligibilityRes));
                    sessionStorage.setItem("objBindInfoRes", JSON.stringify(this.objBindInfoRes));
                    this.router.navigate(['/NewDashboard/UpgradePremiumInfo']);
                }
            }, (error) => {
                this.isShowLoading = false;
            });
    }



}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/Upgrade/Upgrade.ts